module.exports = __webpack_public_path__ + "static/img/guanwang11.73ccfdf7.png";